import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default new Router({
  routes: [{
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        hidden: false,
        title: "登录",
        allowBack: false
      },
      component: () => import('@/view/LoginNew.vue')
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        hidden: false,
        title: "TIC"
      },
      component: () => import('@/view/Home.vue'),
      children: [{
        path: 'fangzhen',
        name: 'fangzhen',
        component: () => import('@/components/fangzhen.vue'),
        meta: {
          title: '仿真实训'
        },
        children: [{
            path: 'work',
            name: 'work',
            component: () => import('@/components/fangzhen/work.vue'),
            meta: {
              title: '仿真实训-课程'
            }
          },
          {
            path: 'stuWork',
            name: 'stuWork',
            component: () => import('@/components/fangzhen/stuWorkNew.vue'),
            meta: {
              title: '仿真实训-课程'
            }
          },
          {
            path: 'stuRenwu',
            name: 'stuRenwu',
            component: () => import('@/components/fangzhen/stuRenwu.vue'),
            meta: {
              title: '仿真实训-任务'
            }
          },
          {
            path: 'workDetail',
            name: 'workDetail',
            component: () => import('@/components/fangzhen/workDetail.vue'),
            meta: {
              title: '仿真实训-课程详情'
            },
            children: [
              {
                path: 'workLsit',
                name: 'workLsit',
                component: () => import('@/components/courseDetails/workLsit.vue'),
                meta: {
                  title: '课程-任务清单'
                }
              },
              {
                path: 'workJilu',
                name: 'workJilu',
                component: () => import('@/components/courseDetails/workJilu.vue'),
                meta: {
                  title: '课程-学习记录'
                }
              },
              {
                path: 'scoreList',
                name: 'scoreList',
                component: () => import('@/components/courseDetails/scoreList.vue'),
                meta: {
                  title: '课程-成绩列表'
                }
              }
            ]
          },
          {
            path: 'renwu',
            name: 'renwu',
            component: () => import('@/components/fangzhen/renwu.vue'),
            meta: {
              title: '仿真实训-任务'
            }
          }
        ],
      }, {
        path: 'manage',
        name: 'manage',
        component: () => import('@/components/classManage.vue'),
        meta: {
          title: '系统管理'
        },
        children: [{
          path: 'classList',
          name: 'classList',
          component: () => import('@/components/manage/classList.vue'),
          meta: {
            title: '班级管理'
          }
        }]
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js